export const getNextPageParam = (lastPage: any) => {
  const currentPage = lastPage.meta?.currentPage ?? 1
  const totalPages = lastPage.meta?.totalPages ?? 1
  return currentPage >= totalPages ? null : currentPage + 1
}
